import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const TrashIcon = ({
  size,
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.474 11.953",
    style: {
      ...svgProps.style,
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    children: [/*#__PURE__*/jsx("path", {
      fill: color,
      d: "M12.084,7.5H4.261A.255.255,0,0,0,4,7.749v6.973a1.02,1.02,0,0,0,1.043,1H11.3a1.02,1.02,0,0,0,1.043-1V7.749A.255.255,0,0,0,12.084,7.5ZM7.26,13.975a.392.392,0,0,1-.782,0V9.492a.392.392,0,0,1,.782,0Zm2.608,0a.392.392,0,0,1-.782,0V9.492a.392.392,0,0,1,.782,0Z",
      transform: "translate(-2.435 -3.765)"
    }), /*#__PURE__*/jsx("path", {
      fill: color,
      d: "M11.953,1.992H9.475a.128.128,0,0,1-.13-.125V1.245A1.276,1.276,0,0,0,8.041,0H5.433a1.276,1.276,0,0,0-1.3,1.245v.623A.128.128,0,0,1,4,1.992H1.522a.5.5,0,1,0,0,1H11.953a.5.5,0,1,0,0-1Zm-6.78-.125V1.245A.255.255,0,0,1,5.433,1H8.041a.255.255,0,0,1,.261.249v.623a.128.128,0,0,1-.13.125H5.3A.128.128,0,0,1,5.172,1.868Z",
      transform: "translate(-1)"
    })]
  });
};

export { TrashIcon };
//# sourceMappingURL=TrashIcon.js.map
